import { type RootState } from "app";
import { useAppSelector } from "app/redux-store-interactions";
import { FeatureToggle } from "config/featureToggles";

export const selectFeatureToggle = (state: RootState, toggle: FeatureToggle): boolean => state.featureToggles[toggle];

export function useFeatureToggle(toggle: FeatureToggle): boolean {
    return useAppSelector((state) => selectFeatureToggle(state, toggle));
}
